<template>
   <div>
     <app-header :title="title" />
     <img v-for="(item, index) in (this.$route.query.index === 0?imgPath2021:imgPath2022)" class="img" width="100%" :src="item.imgPath" alt="" :key="index"/>
   </div>
</template>

<script>
export default {
  name: 'full-course',
  data() {
    return {
      title: '课程详情',
      imgPath2021: [
        { imgPath: 'https://img-cdn1.ylyk.com/image/1634796699047_m1634796209610_s384361.jpg' },
        { imgPath: 'https://img-cdn1.ylyk.com/image/1634796699047_m1634796209643_s416578.jpg' },
        { imgPath: 'https://img-cdn1.ylyk.com/image/1634796699047_m1634796209590_s391594.jpg' },
        { imgPath: 'https://img-cdn1.ylyk.com/image/1634796699047_m1634796209717_s382151.jpg' }
      ],
      imgPath2022: [
        { imgPath: 'https://img-cdn1.ylyk.com/image/1634796699047_m1634797072553_s379679.jpg' },
        { imgPath: 'https://img-cdn1.ylyk.com/image/1634796699047_m1634797072438_s395751.jpg' },
        { imgPath: 'https://img-cdn1.ylyk.com/image/1634796699047_m1634797072506_s413610.jpg' },
        { imgPath: 'https://img-cdn1.ylyk.com/image/1634796699047_m1634797072594_s422748.jpg' }
      ]
    }
  },
  activated() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
}
</script>

<style scoped>
.img{
  display: block;
  vertical-align: top;
}
</style>
